module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/cx-logo-bcbe4eda64cd616f06d0851c1317af6e.png";